// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    setFullPageLayout: ['payload'],
    setStep: ['payload'],
    addFile: ['payload'],
    removeFile: null,
    setColumnsAndRows: ['payload'],

    getSystemFieldsRequest: null,
    getSystemFieldsSuccess: ['payload'],
    getSystemFieldsFailure: null,

    // removeMappedColumn: ['payload'],
    // updateMappedColumns: ['payload'],

    matchColumn: ['payload'],
    unmatchColumn: ['payload'],
    reset: null,

    checkUnidentifiedCategoriesRequest: ['payload'],
    checkUnidentifiedCategoriesSuccess: ['payload'],
    checkUnidentifiedCategoriesFailure: null,

    checkDefaultCategoryRequest: ['payload'],
    checkDefaultCategorySuccess: ['payload'],
    checkDefaultCategoryFailure: null,

    saveBulkCostCodesRequest: ['payload'],
    saveBulkCostCodesSuccess: ['payload'],
    saveBulkCostCodesFailure: null,

    setImportUnmatchedColumns: ['payload'],
    setImportUnidentifiedCategories: ['payload'],

    removeDuplicateRows: null,
    removeEmptyMandatoryFields: null,
  },
  { prefix: 'COST_CODE_IMPORT/' },
);

export default Creators;
